
<div mat-dialog-title>Your File Contains Securities not in iRebal<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content style="overflow:auto !important;">
  <mat-card class="warn block">
    <mat-card-title class="warn">{{data.noninventoried.Models?.length}} model
      contains {{data.noninventoried.Securities?.length}} securities that aren't in iRebal.
    </mat-card-title>
  </mat-card>
  <table width="100%">
    <tr>
      <td style="vertical-align: top; width: 72px; padding: 10px 0;"><strong>Models:</strong></td>
      <td style="padding: 10px;">
        <div
          style="overflow-y: auto; width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
          @if (data.noninventoried.Models && data.noninventoried.Models.length > 0) {
            <table style="width:100%;">
              @for (account of data.noninventoried.Models; track account; let i = $index) {
                <tr>
                  <td
                  style="max-width: 410px; white-space:nowrap; text-overflow: ellipsis;">{{data.noninventoried?.Models[i]}}</td>
                </tr>
              }
            </table>
          }
        </div>
      </td>
    </tr>
  </table>
  <div>The models above contain securities that are in Schwab's security master, but are NOT in iRebal. Those
    securities (below) will be added to iRebal automatically when you continue. You can choose to assign each to a
    custom category.
  </div>
  <div>
    <irb-inventory-grid
      [style.width]="'100%'"
      [style.height]="'240px'"
      [showSideBar]="false"
      [gridOptions]="gridOptions"
      [frameworkComponents]='frameworkComponents'
      [rowData]='data.noninventoried.Securities'
    (gridReady)="onGridReady($event)"></irb-inventory-grid>
  </div>
  <div>When you continue, the models will be imported and the securities added to the iRebal master</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
  <button id="continueButton" (click)="completeContains()" class="btn-medium-primary">Continue</button>
</mat-dialog-actions>
